var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8H26.8019C26.9484 8 27.093 8.03217 27.2257 8.09424C27.3584 8.15632 27.4758 8.24677 27.5696 8.35921C27.6635 8.47166 27.7315 8.60334 27.7688 8.74496C27.8062 8.88659 27.812 9.03468 27.7858 9.17879L25.6052 21.1788C25.5634 21.4092 25.4419 21.6176 25.2621 21.7677C25.0823 21.9178 24.8555 22 24.6213 22H8.38982C8.15572 22 7.92904 21.9179 7.74927 21.7679C7.5695 21.618 7.44804 21.4097 7.40604 21.1794L4.24055 3.8206C4.19855 3.5903 4.07709 3.38203 3.89732 3.23208C3.71755 3.08213 3.49087 3 3.25677 3H1",
    stroke: "#009fd1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 29C10.1046 29 11 28.1046 11 27C11 25.8954 10.1046 25 9 25C7.89543 25 7 25.8954 7 27C7 28.1046 7.89543 29 9 29Z",
    fill: "#009fd1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29C25.1046 29 26 28.1046 26 27C26 25.8954 25.1046 25 24 25C22.8954 25 22 25.8954 22 27C22 28.1046 22.8954 29 24 29Z",
    fill: "#009fd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlueIcon);
export default __webpack_public_path__ + "static/media/cartBlueIcon.808d8dfa8c31603519e33a57c285ecd1.svg";
export { ForwardRef as ReactComponent };